const errorConstants = {
  GENERAL_ERR: 'General error',
  APP_CATCH_ERR: 'App Catch error',
  VALIDATION_FAILS: 'Validation  error',
  ACTION_ERR: 'An error has occurred, please try again!',
  ERR_INVALID_TEMPLATE: 'Invalid template. Please download the latest format',
  ERR_INVALID_FILE_HEADERS: 'These column(s) are missing in your file: ',
  ERR_ADDITIONAL_FILE_HEADERS: 'There are additional column(s) in your file',
  BULK_UPLOAD_FAILS: 'Bulk upload unsuccessful!',
  BULK_UPLOAD_DUPLICATE_RECORDS: 'Bulk upload failed! Duplicate Records found',
  BULK_UPLOAD_TAKES_LONGER: 'This is taking longer than expected, please check back in sometime. Please check master for any rejections.',
  BULK_UPLOAD_PROCESSING: 'Processing Bulk Upload',
  401: 'Unauthorized',
  400: 'Bad Request',
  403: "You don't have the necessary permissions to perform this action",
  404: '404 Not Found',
  500: 'Unable to process your request',
  503: 'Unable to process your request',
  504: '504 Timeout',
  409: 'Conflicting Action',
  OPTIMA_INDENT_CHECK_FAILS: 'Unable to generate indent list',
  OPTIMA_REJECTED_MATERIALS: 'Some materials have not been fitted!',
  OPTIMA_ALREADY_IN_QUEUE: 'Another optima request in progress for this depot!',
  BULK_UPLOAD_MIRO_FAILS: 'Bulk upload unsuccessful!',
  LISTING_FAILS: 'Initial data load problem. Please try again!',
  FEILDS_MISSING: 'Mandatory fields missing',
  INDENT_CREATION_FAILS: 'Indent creation failed!',
  INDENT_UPDATION_FAILS: 'Indent updation failed!',
  EXPORT_FAILS: 'Export failed. Please try after some time',
  PAYMENT_DOWNLOAD_FAILS: 'Download failed. Please try after some time',
  ERR_NO_RECORD_FOUND: 'Empty Record has uploaded',
  ERR_INVALID_FILE_EXTENSION: 'Invalid file extension. Use .xls or .xlsx format',
  EXISTS_PICKUP: 'Pickup already added',
  ERR_FREIGHT_UPDATE: 'Invoice generated for this Indent',
  ERR_INVALID_ORDER_TYPE: 'Freight updation not applicable for this Indent',
  ERR_INVALID_REQUEST_DATA: '',
  ERR_DUPLICATE_REFERENCE_ID: 'Already Exists',
  ERR_CONFIG_MISSING: 'The feature has been disabled',
  ERR_SYSTEM_USER: 'System role user cannot be updated',
  INDENT_HAS_NO_GATE: 'Select the Gate',
  UPDATE_FAILURE: 'Changes have not been updated!',
  COMMENT_ADD_FAILURE: 'Unable to add comment.',
  INCREMENT_BLOCKING: 'Cannot increment the value',
  DECREMENT_BLOCKING: 'Cannot decrement the value',
  UPDATE_NO_CHANGES: 'No Changes have been made by the user!',
  INVOICE_CREATION_FAILURE: 'Invoice creation failed',
  STATUS_UPDATE_FAILURE: 'Update failed',
  FILTER_NOT_APPLICABLE: 'Current filters are not applicable',
  DATE_FILTER_ERROR: 'Report available only for a single date',
  NO_REPORT_SELECTED: 'Please select any report',
  UPLOAD_LIMIT_EXCEED: 'Upload Limit Exceeded',
  FILE_SIZE_EXCEED: 'Size can not exceed 12MB!',
  INVALID_FORMAT: 'Invalid file format',
  UPLOAD_FAILS: 'Upload failed!',
  CASES_EXCEED: 'Number of Cases cannot exceed the total quantity',
  CASES_PIECES_EXCEED: 'Number of Cases/Pieces cannot exceed the total quantity',
  DELETE_FILE_FAILS: 'Remove file failed!',
  PIECES_EXCEED: 'Number of Pieces cannot exceed the total quantity',
  LITRES_EXCEED: 'Number of Litres cannot exceed the total quantity',
  EMPTY_QUANTITY: 'Amount cannot be entered with zero quantity',
  AMOUNT_ZERO: 'Amount should be greater than zero',
  LEAKAGE_EXCEEDED: 'leakage count cannot exceed the total quantity',
  SHORTAGE_DAMAGE_EXCEED: 'Shortage and Damage count cannot exceed the total quantity',
  AMOUNT_EXCEEDED: 'Amount should be less than mrp of the total quantity',
  QTY_NEG: 'Quantity should be greater or equal to zero',
  AMT_NEG: 'Amount should be greater or equal to zero',
  TONS_EXCEED: 'Number of Tons cannot exceed the total weight',
  KG_EXCEED: 'Number of Kgs cannot exceed the total weight',
  TONS_KG_EXCEED: 'Number of Tons/Kgs cannot exceed the total weight',
  ARRIVAL_CUTOFF_ERROR: 'Arrival cutoff should be greater than Indent cutoff',
  AUTO_CANCEL_CUTOFF_ERROR: 'Auto cancel cutoff should be greater than Indent cutoff',
  GRN_SUBMIT_FAILED: 'GRN approval failed',
  GRN_SAVE_FAILED: 'GRN save failed',
  RETRIGGER_EPOD_FAILED: 'Re-Trigger EPOD failed',
  HOURS_ERROR: 'Hours should be between 0 and 24',
  MINUTES_ERROR: 'Minutes should be between 0 and 59',
  BID_SLOT_MIN_ERROR: 'Bid slot time should be atleast 30 minutes',
  BID_DECREMENT_PERCENTAGE_ERROR: 'Bid decrement percentage should be between 0 - 100',
  BID_DECREMENT_MIN_ERROR: 'Bid decrement value should be greater than 0',
  LEADING_BID_BUFFER_PERCENTAGE_ERROR: 'Leading bid buffer percentage should be between 0 - 100',
  LEADING_BID_MIN_ERROR: 'Leading did value should be greater than 0',
  OPTIMA_ABORT_SOME_INVALID_MATERIALS: 'Optima run aborted as some materials are invalid',
  OPTIMA_FOR_PTL_COULD_HAVE_RUN: 'Optima for PTL enabled, PTL indents expected',
  OPTIMA_JOB_NOT_CREATED: 'Optima is not able to process all the deliveries. Please check rejections',
  OPTIMA_JOB_NOT_CREATED_CHECK_REJECTIONS: 'Optima is not able to process all the deliveries. Please check rejections',
  FACTOR_VALUE_EXCEED: 'Factor value must be between 0 and 1',
  THRESHOLD_VALUE_EXCEED: 'Threshold value must be greater than 0',
  INVALID_VEHICLE_NUMBER: 'Please enter a valid vehicle number',
  NEED_LICENSE_FOR_DRIVER_VALIDATION: 'Please enter a valid driver license number',
  NEED_DOB_FOR_DRIVER_VALIDATION: 'Please enter a valid driver DOB',
  INVALID_MOBILE_NUMBER: 'Please enter a valid mobile number',
  INVALID_ESTIMATED_ARRIVAL_DATE_TIME: 'Please enter a valid estimated arrival date',
  NEED_LICENSE_FOR_DRIVER_VALIDATION: 'Please enter a valid license number',
  NEED_DOB_FOR_DRIVER_VALIDATION: 'Please enter a valid driver DOB',
  LR_REQUIRED: 'LR Number cannot be empty',
  BLACKLIST_DRIVER_FAILURE: 'Cannot fetch driver blacklist status',
  BLACKLIST_VEHICLE_FAILURE: 'Cannot fetch vehicle blacklist status',
  OTP_FAILED: 'OTP Number Incorrect',
  ERR_DUPLICATE_FREIGHT_FORWARDER: 'Duplicate Record',
  NO_COMMENT_ENTERED: 'No comment entered!',
  DEBIT_ADJUSTMENT_INVALID: 'Adjustment amount cannot be higher than \'Total debited amount\'',
  DEBIT_ADJUSTMENT_NEGATIVE: 'Adjustment amount cannot be negative',
  DEBIT_ADJUSTMENT_FAILED: 'Updating debit adjustment failed',
  ERR_ORDER_INVALID_STATUS: 'The operation is invalid in current status of the order',
  DUPLICATE_HSN_SAC: 'Duplicate SAC name or code. Please check.',
  NAME_EMPTY_ERROR: 'Name should not be empty',
  CODE_EMPTY_ERROR: 'Code should not be empty',
  IMPROPER_CODE_ERROR: 'Code should be alphanumeric',
  CERTIFICATE_UPDATE_ERROR: 'Certification details not updated',
  AVATAR_FORMAT_ERROR: 'Avatar picture must be JPG format!',
  AVATAR_SIZE_ERROR: 'Avatar picture size can not exceed 2MB!',
  NO_FILE: 'No file selected',
  DASHBOARD_NOT_DEFINED: 'Dashboard not Available',
  REQUIRED_ERROR: ' is required field',
  CONSIGNMENT_UPDATE_FAILURE: 'Consignment number updated failed!',
  CONSIGNMENT_UPDATE_INVALID: 'Consignment number is not valid. Enter the correct consignment number to begin tracking.',
  CONSIGNMENT_UPDATE_EMPTY: 'Please change the consignment number to save!',
  CONSIGNMENT_NOT_FOUND: 'Consignment not found',
  TIMEOUT: 'No Response- Timeout by - #firstArgument# ',
  FREIGHT_RATE_MISSING: 'Freight rate missing',
  LR_NOT_AVAILABLE: 'Physical LR not available',
  DEDICATED_TRUCK_NOT_COMBINE: 'Cant combine Dedicated truck orders with others',
  FTL_PTL_NOT_COMBINE: 'Can\'t combine FTL and PTL orders',
  MOVEMENT_NOT_COMBINE: 'Can\'t combine indents from multiple movements',
  PO_NOT_COMBINE: 'Two different PO Indents cannot be combined',
  UTILIZATION_CHECK: 'Pending Utilization Check',
  EXIM_MASTER_CANCEL_FAILS: 'Master Indent Cancel Failed',
  EXIM_MASTER_DELIVER_FAILS: 'Master Indent Deliver Failed',
  CLEAR_AGED_PAYMENTS: 'Please clear older ready for billing items first',
  CLEAR_AGED_RETURN_INVOICES: 'Please clear aged Returned Invoices first',
  CREATE_RETURN_FAILURE: 'Return indent creation failed!',
  OTP_GENERATION_EXPIRED: 'OTP generation is exceeded as you have already resent the otp 3 times!',
  SO_UPDATE_FAILURE: 'SO number save failed!',
  INVALID_CONTAINER_NUMBER: 'Please enter a valid container number',
  INVALID_LINE_SEAL_NUMBER: 'Please enter a valid line seal number',
  DRAFT_CREATION_FAILS: 'Draft creation fails',
  EXPORT_DATE_RANGE_EXCEED: 'Date range for export cannot exceed 31 days. Please select a value less than or equal to 31 days',
  MOVEMENT_NOT_REQUIRED: 'Please select all movement to enable this report',
  NOT_AVAILABLE_FOR_PRIMARY: 'Not available for primary movement',
  NOT_AVAILABLE_FOR_SECONDARY: 'Not available for secondary movement',
  NOT_AVAILABLE_FOR_VENDOR: 'Not available for  vendor movement',
  NOT_AVAILABLE_FOR_RETURNS: 'Not available for returns movement',
  RETRY_FAILED: 'Retry Failed',
  FREIGHT_INVOICE_FAILED: 'Freight Invoice could not be posted in ERP',
  CANCELLATION_FAILED: 'Cancellation on Invoices Failed',
  PRIMARY_MOVEMENT_NOT_COMBINE: 'Can\'t combine Primary movement with other movements',
  TRUCKIN_AFTER_ASSIGNED: 'Truck In time should be after assigned',
  DELIVERY_NUMBER_UPDATE_FAILURE: 'Delivery number save failed!',
  UPDATE_MATERIAL_FAILED: 'Update Material data failed',
  INVOICE_UPLOAD_NEEDED: 'Invoice Upload Needed',
  INVOICE_IRN_EXPIRED: 'IRN Expired',
  INVOICE_VERIFICATION_NEEDED: 'Invoice Verification Needed',
  VERIFY_INVOICE_FAILS: 'Invoice Verification Failed',
  TRANSIT_PENALTY_CONFIG_SAVE_FAILED: 'Transit Penalty Config update failed',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  CEILING_PRICE_ERROR: 'Please enter Bid amount less than ceiling price',
  SLAB_ID_NOT_EXISTS: 'Slab Id does not exists',
  PRODUCT_CATEGORY_ID_NOT_EXISTS: 'Product Category Id does not exists',
  VENDOR_DEPOT_ERROR: 'Unable to save Vendor Depot',
  VENDOR_DEPOT_UPDATE_ERROR: 'Unable to update Vendor Depot',
  WALLET_AUTO_APPROVEL_DAYS: 'Auto approval days: Please select a value between 0 to 90',
  ACTION_PENDING_ON_SHIPPER: 'Action pending on Shipper',
  EPOD_REJECT_FAILED: 'EPOD Rejection failed',
  RECONCILIATION_ERROR: 'Package Update faild',
  UNABLE_TO_LOAD: 'Unable to load data',
  LIMIT_CUSTOM_FIELDS: 'Cannot add more than 5 custom attributes',
  INDENT_CREATED_IN_DIFFERENT_MONTH_NOT_COMBINE: 'Can\'t combine indents created in different months',
  INDENT_DELIVERED_IN_DIFFERENT_MONTH_NOT_COMBINE: 'Can\'t combine indents delivered in different months',
  COMBINE_INDENT_WITH_DIFFERENT_DROPS: 'Can\'t combine Indents with different drops',
  COMBINE_CANCELLED_AND_DELIVERED_INDENTS: 'Can\'t combine cancelled and delivered indents',
  LEGAL_ENTITY_LOAD_ERROR: 'Cannot load legal entity',
  CURRENCY_ADJUSTMENT_DUPLICATE_ROWS: 'Table contains duplicate rows.',
  CURRENCY_SELECTION_IDENTICAL: 'From Currency and To Currency cannot contain same value',
  FEE_LIMIT_EXCEEDED: 'Adjustment Fee % should be less than or equal to 100',
  ERR_ALREADY_RETRIGGERED: 'Retrigger already initiated',
  PAYMENT_GENERATION_FAILED: 'Payment generation failed',
  DEPOT_FILTER_ERROR: 'Need minimum one depot selection',
  DATE_FILTER_RANGE_EXCEED: 'Date range cannot exceed 12 months',
  LIMIT_REASON_FIELDS: 'Cannot add more than 10 reasons',
  DATE_FILTER_RANGE_EXCEED: 'Date range cannot exceed 12 months',
  DIFFERENT_LEGAL_ENTITY: 'Can\'t combine Indents with different legal entity',
  LR_REJECT_FAILS: 'LR Rejections Failed',
  NO_ACTION_PERMISSION: "You don't have the necessary permissions to perform this action",
};

export default errorConstants;
